import { render, staticRenderFns } from "./PH1V_S6.vue?vue&type=template&id=bd16bd42&scoped=true"
import script from "./PH1V_S6.vue?vue&type=script&lang=js"
export * from "./PH1V_S6.vue?vue&type=script&lang=js"
import style0 from "./PH1V_S6.vue?vue&type=style&index=0&id=bd16bd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd16bd42",
  null
  
)

export default component.exports